export type IReloadPage = (delay?: number) => void;

export function reloadPage(delay = 0): void {
  setTimeout(() => {
    document.location.reload(true); // https://developer.mozilla.org/en-US/docs/Web/API/Location/reload#forceget
  }, delay);
}
